import React from 'react'
import { Link } from 'react-router-dom';
import { Version } from '../..';
import { useDrawer } from '../../Hook/App';

function Index({ right, change }) {
    const {
        ref,
        user,
        Clickout,
        navigate,
        styleLayer,
        clearFliter,
        logout,
        styleContent } = useDrawer(right, change);
    return (
        <div style={styleLayer} className="col-lg-4 drawer-layer" onClick={Clickout}>
            <div className="drawer" ref={ref} style={styleContent}>
                <div className="header">
                    {user ?
                        <button onClick={() => navigate("/UserProfile")}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex">
                                    <div className="img">
                                        <img src={user.meta_data && user.meta_data.profile} alt="image" />
                                    </div>
                                    <div className="info align-items-center d-grid">
                                        <p>{user.name}</p>
                                        <span>{user.mobile}</span>
                                    </div>
                                </div>
                                <i className="fas fa-pencil"></i>
                            </div>
                        </button>
                        :
                        <button onClick={() => navigate("/UserProfile")}>
                            <span className='text-white'>ورود به حساب کاربری</span>
                        </button>
                    }
                </div>
                <div className="drawer-main">
                    <a onClick={clearFliter}>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-home'></i>
                            <span className="title">همه آگهی ها</span>
                        </div>
                    </a>
                    <Link to={'/AddItem'}>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-plus'></i>
                            <span className="title">ثبت رایگان آگهی</span>
                        </div>
                    </Link>
                    <Link to={'/UserProfile'}>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-list'></i>
                            <span className="title">آگهی های من</span>
                        </div>
                    </Link>
                    <Link to={'/Favorites'}>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-star'></i>
                            <span className="title">آگهی های پسندیده</span>
                        </div>
                    </Link>
                    <Link to='/saved'>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-bell'></i>
                            <span className="title">جستجوهای ذخیره شده</span>
                        </div>
                    </Link>
                    <Link to='/messages'>
                        <div onClick={() => navigate("Messages")} className="d-flex align-items-center mb-4">
                            <i className='fas fa-comments'></i>
                            <span className="title">چت های من</span>
                        </div>
                    </Link>
                    <Link to='/Notification'>
                        <div className="d-flex align-items-center mb-4">
                            <i className='fas fa-info-circle'></i>
                            <span className="title">اعلانات</span>
                        </div>
                    </Link>
                    <Link to='/StoreList'>
                        <div className="d-flex align-items-center mb-2">
                            <i className='fas fa-store'></i>
                            <span className="title">همه فروشگاه ها</span>
                        </div>
                    </Link>
                    <div className="yborder">
                        <Link to='/settings'>
                            <div className="d-flex align-items-center mb-4 mt-3">
                                <i className='fas fa-cogs'></i>
                                <span className="title">تنظیمات</span>
                            </div>
                        </Link>
                        <Link to='/Support'>
                            <div className="d-flex align-items-center mb-3">
                                <i className='fas fa-question'></i>
                                <span className="title">تماس با ما</span>
                            </div>
                        </Link>
                        <Link to='/complaint'>
                            <div className="d-flex align-items-center mb-3">
                                <i className='fas fa-bug'></i>
                                <span className="title">ثبت شکایت</span>
                            </div>
                        </Link>
                    </div>
                    {user &&
                        <a onClick={() => { localStorage.clear(); logout() }}>
                            <div className="d-flex align-items-center mb-4 mt-3">
                                <i className='fas fa-home'></i>
                                <span className="title">خروج از حساب کاربری</span>
                            </div>
                        </a>
                    }
                </div>
                <div className="footer">
                    <div className="d-flex justify-content-center">
                        <span>app version {Version}</span>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Index
